import gearboxes, { gearboxNames } from '@constants/values/gearboxes'

const skrzyniaBiegow = {
    name: 'skrzynia-biegow',
    names: gearboxNames,
    options: gearboxes,
    t: 'Skrzynia biegów',
    type: 'all-checkbox',
}

export default skrzyniaBiegow